import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    standalone: false,
})
export class FileUploadComponent implements AfterViewInit {
    @ViewChild('fileInput') fileInput: ElementRef;

    @Input() type: string;
    @Output() fileChange: EventEmitter<File> = new EventEmitter<File>();
    file: File;

    ngAfterViewInit() {
        if (this.type) {
            /* eslint-disable-next-line  @typescript-eslint/no-unsafe-member-access */
            this.fileInput.nativeElement.accept = this.type;
        }
    }

    openDialog(fileInput: HTMLInputElement): void {
        this.file = null;
        fileInput.value = null;
        this.fileChange.emit(undefined);
        fileInput.click();
    }

    fileSelected(fileInput: HTMLInputElement): void {
        this.processFile(fileInput.files);
    }

    processFile(files: FileList): void {
        if (files.length) {
            this.file = files[0];
            this.fileChange.emit(this.file);
        }
    }
}
